module.exports = "/assets/f35ea704e272252378cdfac0028a20f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RB.png
// module id = 2903
// module chunks = 0